import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { redirect as Redirect } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Header from './components/Header' 
import Home from './pages/Home'
import UserProfile from './pages/UserProfile'
import Settings from './pages/Settings'
import Messenger from './pages/Messenger/Messenger'
import MessagePanelMobile from 'components/messenger/MessagePanelMobile'
import Notifications from './pages/Notifications'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import SinglePost from './pages/SinglePost'
import SelectedConversation from './pages/Messenger/SelectedConversation'
import ChurchThread from './pages/Messenger/ChurchThread'
import NewConversation from './pages/Messenger/NewConversation' 
import UserProfileChurch from './pages/UserProfileChurch'
import MyProfile from './pages/MyProfile'
import Posts from './pages/postsPage/Posts'
import MyPosts from './pages/postsPage/MyPosts'
import PostsFromMemb from './pages/postsPage/PostsFromMemberships'
import Saved from './pages/postsPage/Saved'
import Pricing from 'pages/information/Pricing'
import PrivacyPolicy from 'pages/aboutPraysely/PrivacyPolicy'
import TermsOfService from 'pages/aboutPraysely/TermsOfService'
import ChildSafetyStandards from 'pages/aboutPraysely/ChildSafetyStandards'
import DeleteDataRequest from 'pages/aboutPraysely/DeleteDataRequest'
import AboutUs from 'pages/landingPage/AboutUs'
import ChurchVerify from 'pages/settings/ChurchVerify'
import FeedbackMain from 'pages/feedback/FeedbackMain'
import BillingPage from './pages/settings/BillingPage'
import NotLoggedInViewChurch from 'pages/NotLoggedInViewChurch'
import SingleEventPage from 'pages/events/SingleEventPage'
import Marketplace from 'pages/Marketplace/Marketplace'
import MyCreatedListingsPage from 'pages/Marketplace/MyCreatedListingsPage'
import MySavedListingsPage from 'pages/Marketplace/MySavedListingsPage'
import { useSelector } from 'react-redux' 
import CreatePostModal from 'components/createPostModal/CreatePostModal'
import StartConversationModal from 'components/messenger/startConversation/StartConversationModal'
import RegisterFromInvite from 'pages/RegisterFromInvite'
import { Modal } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { addAc } from 'features/auth/authSlice'
import { addAcFunc } from 'funcs/ac'
import AudioPlayer from 'components/media/audio/AudioPlayer'
import styled from 'styled-components'
import SingleCampaign from 'pages/giving/SingleCampaign'
import AuthLogin from 'pages/auth/Login'
import AuthRegister from 'pages/auth/Register'
import QASession from 'pages/QASession'
import ReportIssueModal from 'components/modals/ReportIssue/ReportIssueModal'
import { setViewReportIssueModal } from 'features/settings/settingSlice'
import E2EESetupModal from 'components/messenger/E2EESetupModal'
import SinglePollPage from 'pages/polls/SinglePollPage'
import Explore from 'pages/Explore'

function App() {

  const { viewCreatePostModal } = useSelector((state) => state.posts)
  const { audioPlayerWindowHeight } = useSelector((state) => state.audioPlayer)
  const { viewStartConversationModal } = useSelector((state) => state.conversations)
  const { viewReportIssueModal } = useSelector((state) => state.settings)  
  const dispatch = useDispatch()

  useEffect(() => {

    const dis = () => dispatch(addAc({
      type: 'logons', 
    }))

    addAcFunc('lg', dis)

  }, [])




  return (
    <>
      {/* E2EE passphrase setup/restore — shown automatically after login */}
      <E2EESetupModal />
      <Router>
        <StyledAppDiv 
          className='container'>
          <Modal
            open={viewCreatePostModal}  
            >
              <div
                style={{ 
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}  
              > 
              <CreatePostModal />
            </div>
          </Modal> 
          <Modal
            open={viewReportIssueModal}
            onClose={() => dispatch(setViewReportIssueModal(false))}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >

            <ReportIssueModal />

        </Modal>
          {
            viewStartConversationModal && <StartConversationModal />
          } 
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/login' element={<AuthLogin />} />  
            <Route path='/register' element={<AuthRegister />} /> 
            <Route path='/user/:profileName' element={<><Header /><UserProfile/></>} />

            {/* for churches */}
            <Route path='/:churchName' element={<><Header /><UserProfileChurch /></>} />  
            <Route path='/church/:churchName' element={<><Header/><NotLoggedInViewChurch /> </>} />

            {/* for users, after user logs in goes here  */}
            <Route path='/home' element={<><Header/><MyProfile /></>} /> 
            <Route path='/explore' element={<><Header/><Explore /></>} />
            <Route path='/settings' element={<><Header /><Settings /></>} />
            <Route path='/settings/billing' element={<><Header /><BillingPage /></>} />
            <Route path='/notifications' element={<><Header /><Notifications /></>} />
            <Route path='/forgot-password' element={<><Header /><ForgotPassword /></>} />
            <Route path='/reset-password/:userType/:token/:email' element={<><Header /><ResetPassword /></>} /> 
            <Route path='/posts/:postId' element={<><Header /><SinglePost /></>} />
            <Route path='/campaigns/:campaignId' element={<><Header /><SingleCampaign /></>} />
            <Route path='events/:eventId' element={<><Header /><SingleEventPage /></>} /> 
            <Route path='/polls/:pollId' element={<><Header /><SinglePollPage /></>} />
            <Route path='/anouncements/:anouncementId' element={<><Header /><SinglePost /></>} />
            <Route path='/view-posts' element={<><Header /><Posts /></>} />
            <Route path='/my-posts' element={<><Header /><MyPosts /></>} />
            <Route path='/church-posts' element={<><Header /><PostsFromMemb /></>} />
            <Route path='/saved-posts' element={<><Header /><Saved /></>} />
            <Route path='/messages' element={<><Header /><Messenger /></>} />
            <Route path='/sessions/:sessionId' element={<><Header /><QASession /></>} /> 

           {/* 
                below here there is an optional parameter that is added after the conversation id: "mm"
                this is to diferentiate between a conversation between two members versus a conversation between a member and a church
                a conversation between member and church will NOT have the "mm" parameter.
                Take a look at PRYS-99 in Jira for a screenshot reference to a stackoverflow post that explains how to do this. Link 
                https://stackoverflow.com/questions/35604617/react-router-with-optional-path-parameter
           */}
            <Route path='/messages/:convId' element={<><Header /><SelectedConversation /></>} />
            <Route path='/messages/church/:churchId' element={<><Header /><ChurchThread /></>} />
            <Route path='/messages/new' element={<><Header /><NewConversation /></>} />
            <Route path='/message/mobile/:convID' element={<><Header/><MessagePanelMobile /></>} /> 
            <Route path='/info/privacy' element={<PrivacyPolicy />} />
            <Route path='/info/privacy/' element={<PrivacyPolicy />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/privacy-policy/' element={<PrivacyPolicy />} />
            <Route path='/info/about/' element={<AboutUs /> } />
            <Route path='/info/pricing/' element={<><Pricing /> </>} />
            <Route path='/info/terms' element={<TermsOfService />} />
            <Route path='/info/terms/' element={<TermsOfService />} />
            <Route path='/terms-of-service' element={<TermsOfService />} />
            <Route path='/terms-of-service/' element={<TermsOfService />} />
            <Route path='/child-safety-standards' element={<ChildSafetyStandards />} />
            <Route path='/child-safety-standards/' element={<ChildSafetyStandards />} />
            <Route path='/delete-my-data' element={<DeleteDataRequest mode='data' />} />
            <Route path='/delete-my-data/' element={<DeleteDataRequest mode='data' />} />
            <Route path='/delete-my-account' element={<DeleteDataRequest mode='account' />} />
            <Route path='/delete-my-account/' element={<DeleteDataRequest mode='account' />} />
            <Route path='/info/feedback/' element={<>< FeedbackMain /> </>} />
            <Route path='/settings/verify-account' element={<><Header/><ChurchVerify /> </>} />
            <Route 
              path='/market/listings/(marketListingType)?/:marketListingType?/(listingCategory)?/:listingCategory?/'  
              element={<><Header/><Marketplace /> </>} 
              /> 
            <Route 
              path='/market/my-listings/'  
              element={<><Header/><MyCreatedListingsPage /> </>} 
              />
            <Route 
              path='/market/my-saved-listings/'  
              element={<><Header/><MySavedListingsPage /> </>} 
              />
            <Route 
              path='/member-register/:addKey/:email'
              element={<><Header/><RegisterFromInvite /> </>} 
              />
          </Routes>

          <AudioPlayerContainer
            height={audioPlayerWindowHeight}
            >
            <AudioPlayer />
          </AudioPlayerContainer>

        </StyledAppDiv>
      </Router>
      <ToastContainer />
    </>
  )
}

export default App


const StyledAppDiv = styled.div`

  @media (max-width: 768px) {
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar{
      display: none;
    }
  }
`

const AudioPlayerContainer = styled.div`
  height: ${props => props.height};
  width: 500px;
  background-color: white;
  position: absolute;
  bottom: 0;
  right: 150px;
  z-index: 1000;
  border-radius: 10px 10px 0 0;
  box-shadow: 0px 0px 5px #ccc;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  transition: all 0.99s;
`
